import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedMessage, LocalizedPrice } from 'intl/LocalizedComponents';
import _last from 'lodash/last';
import _map from 'lodash/map';
// Core components
import Table from 'components/core/table/Table';
import TableHead from 'components/core/table/TableHead';
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import Typography from 'components/core/Typography';
// Models
import mPriceGrid from 'models/cpm/priceGrid';
import mPriceRule from 'models/cpm/priceRule';
// Custom
import { cpmPriceGridDataShape, cpmBookingPriceGridDataShape } from 'constants/PropTypesShapes';

const PriceGridTable = ({ priceGrid }) => {
  const sortedTiers = mPriceGrid.sortTiers(priceGrid);
  const lastUnit = _last(sortedTiers).unit;

  return (
    <Table
      hasElements
      head={(
        <TableHead
          columns={[
            {
              key: 'duration',
              labelId: 'field.parkingDuration',
              field: 'duration',
              sortable: false,
            },
            {
              key: 'price',
              labelId: 'field.rate',
              field: 'price',
              sortable: false,
              className: 'table-content-2 table-content-center',
            },
          ]}
        />
      )}
      withFooter={false}
    >
      <React.Fragment>
        {_map(mPriceGrid.sortTiers(priceGrid), (tier) => (
          <TableRow key={mPriceGrid.tierKey(tier)}>
            <TableCell>
              <LocalizedMessage id="info.duration" values={{ duration: tier.duration, unit: tier.unit }} />
            </TableCell>
            <TableCell className="table-content-2 table-content-center">
              <Typography type="keyInfo4">
                {tier.amountInclTax === 0 ? (
                  <LocalizedMessage id="info.free" />
                ) : (
                  <LocalizedPrice
                    currency={priceGrid.priceRule.currency}
                    value={mPriceRule.displayAmount(tier.amountInclTax, priceGrid.priceRule)}
                  />
                )}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell noBorder>
            <em><LocalizedMessage id="info.durationAdditional" values={{ unit: lastUnit }} /></em>
          </TableCell>
          <TableCell noBorder className="table-content-2 table-content-center">
            <Typography type="keyInfo4">
              <LocalizedPrice
                currency={priceGrid.priceRule.currency}
                value={mPriceRule.displayAmount(priceGrid.additional.amountInclTax, priceGrid.priceRule)}
              />
            </Typography>
          </TableCell>
        </TableRow>
      </React.Fragment>
    </Table>
  );
};

PriceGridTable.propTypes = {
  priceGrid: PropTypes.oneOfType([
    cpmPriceGridDataShape,
    cpmBookingPriceGridDataShape,
  ]).isRequired,
};

module.exports = PriceGridTable;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/priceGrids/PriceGridTable.js